import {
  EXPANSION_CATEGORIES,
  EXPANSION_SERVICE,
  EXPANSION_SERVICE_MAP,
  EXPANSION_PAGE_SLUGS,
  INDIA,
} from './site-expansion';
import {
  BUSINESS_CATEGORIES,
  BUSINESS_SERVICES,
  BUSINESS_PAGE_SLUGS,
  PROGRAMME_CATEGORIES,
  PROGRAMME_SERVICES,
  PROGRAMME_PAGE_SLUGS,
  EUROPE,
} from './site-sectors';

export const IMG = {
  machining:
    'https://images.unsplash.com/photo-1652888510609-ed2d2ad64d6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxwcmVjaXNpb24lMjBtYWNoaW5pbmclMjB3b3Jrc2hvcHxlbnwwfHx8fDE3ODg5MTczMjJ8MA&ixlib=rb-4.1.0&q=85',
  automation:
    'https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwZWxlY3RyaWNhbCUyMGF1dG9tYXRpb258ZW58MHx8fHwxNzg4OTE3MzIyfDA&ixlib=rb-4.1.0&q=85',
  electrical:
    'https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZWxlY3RyaWNhbCUyMGF1dG9tYXRpb258ZW58MHx8fHwxNzg4OTE3MzIyfDA&ixlib=rb-4.1.0&q=85',
  founder:
    'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBmb3VuZGVyJTIwaGVhZHNob3R8ZW58MHx8fHwxNzg4OTE3MzIyfDA&ixlib=rb-4.1.0&q=85',
};

export const CONTACT_EMAIL = 'hello@voxmeridian.com';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/vox-meridian-ab8456385';
export const X_URL = 'https://x.com/vox_meridian';

// CATEGORIES carry GLOBAL copy by default. The original Singapore-targeted copy is
// preserved verbatim under `sg` and rendered on the /services/<slug>/sg country page.
export const CATEGORIES = [
  {
    slug: 'precision-machining',
    name: 'Precision Machining',
    keyword: 'precision machining services',
    tagline: 'CNC milling, turning and grinding held to microns — prototype to production.',
    image: IMG.machining,
    intro: [
      'Precision engineering supports the most demanding supply chains in the world — aerospace, semiconductors, medical devices and offshore energy. When a drawing calls for ±0.005 mm, you need a machining partner that measures what it makes and makes what it measures. Vox Meridian connects you with precision machining services across nine countries — shops that run modern CNC mills, lathes and EDM lines, and that understand GD&T, FAIs and material traceability.',
      'Instead of cold-calling shops across industrial estates, post one RFQ and receive comparable quotes from verified machining providers in your country. Every provider is reviewed for business registration and capability before they ever see your drawings.',
    ],
    servicesTitle: 'Capabilities our machining providers quote on',
    services: [
      '3, 4 and 5-axis CNC milling',
      'CNC turning and Swiss-type turning',
      'Wire-cut and sinker EDM',
      'Surface, cylindrical and jig grinding',
      'Prototyping and low-volume production',
      'Hard machining and exotic alloys (Inconel, titanium)',
      'CMM inspection with full reports',
      'Surface treatment and finishing coordination',
    ],
    sections: [
      {
        h: 'How buyers use Vox Meridian for machining work',
        paragraphs: [
          'Post your RFQ with the drawing pack attached — STEP files, PDFs, tolerances and material specs. Tell us your target budget band and required-by date. The founder personally matches your job to three to five shops in your country whose machines, envelope sizes and quality systems fit the work — targeting 24–48 hours, and telling you honestly if the match needs more sourcing time.',
          'You receive comparable, like-for-like quotes instead of a folder of mismatched emails. Because providers know they are competing in a small, qualified pool, pricing stays sharp and responses stay fast. There is no platform fee for buyers during the pilot phase.',
        ],
      },
      {
        h: 'Why machining shops join as providers',
        paragraphs: [
          'Most machine shops win work through word of mouth and walk-ins. That leaves expensive spindles idle between jobs. As a founding provider you receive pre-qualified RFQs that match your declared capabilities — no cold outreach, no trade-show spend, no tyre-kickers.',
          'Founding providers lock a rate of SGD 29 per month for life. Verification of your business registration, shopfloor capability and insurance is handled by the founder personally during the concierge phase, which keeps quote quality high for buyers and competition fair for you.',
        ],
      },
    ],
    sg: {
      keyword: 'precision machining services Singapore',
      intro: [
        'Singapore’s precision engineering sector supports some of the most demanding supply chains in the world — aerospace, semiconductors, medical devices and offshore energy. When a drawing calls for ±0.005 mm, you need a machining partner that measures what it makes and makes what it measures. Vox Meridian connects you with precision machining services in Singapore that run modern CNC mills, lathes and EDM lines, and that understand GD&T, FAIs and material traceability.',
        'Instead of cold-calling shops across Tuas, Woodlands and Ubi, post one RFQ and receive comparable quotes from verified Singapore machining providers. Every provider on the platform is an ACRA-registered entity, reviewed for capability before they ever see your drawings.',
      ],
      sections: [
        {
          h: 'How buyers use Vox Meridian for machining work',
          paragraphs: [
            'Post your RFQ with the drawing pack attached — STEP files, PDFs, tolerances and material specs. Tell us your target budget band and required-by date. The founder personally matches your job to three to five Singapore shops whose machines, envelope sizes and quality systems fit the work — targeting 24–48 hours, and telling you honestly if the match needs more sourcing time.',
            'You receive comparable, like-for-like quotes instead of a folder of mismatched emails. Because providers know they are competing in a small, qualified pool, pricing stays sharp and responses stay fast. There is no platform fee for buyers during the pilot phase.',
          ],
        },
        {
          h: 'Why machining shops join as providers',
          paragraphs: [
            'Most Singapore machine shops win work through word of mouth and walk-ins. That leaves expensive spindles idle between jobs. As a founding provider you receive pre-qualified RFQs that match your declared capabilities — no cold outreach, no trade-show spend, no tyre-kickers.',
            'Founding providers lock a rate of SGD 29 per month for life. Verification of your ACRA UEN, shopfloor capability and insurance is handled by the founder personally during the concierge phase, which keeps quote quality high for buyers and competition fair for you.',
          ],
        },
      ],
    },
  },
  {
    slug: 'mro-services',
    name: 'MRO Services',
    keyword: 'industrial MRO services',
    tagline: 'Maintenance, repair and overhaul contractors who keep plants running.',
    image: IMG.electrical,
    intro: [
      'Unplanned downtime is the most expensive line item nobody budgets for. When a pump seals, a conveyor fails or a chiller trips at 2 a.m., you need industrial MRO services that answer the phone and turn up with the right spares. Vox Meridian routes your maintenance, repair and overhaul RFQs to verified MRO contractors in your country — from process plants to manufacturing estates.',
      'Post one RFQ describing the asset, the fault or the maintenance scope, and your timeline. We match you with registered, safety-reviewed MRO providers who have done the same class of work before — rotating equipment, static equipment, facilities and utilities.',
    ],
    servicesTitle: 'MRO scopes our providers quote on',
    services: [
      'Preventive and predictive maintenance contracts',
      'Pump, gearbox and rotating equipment overhaul',
      'Heat exchanger and pressure vessel servicing',
      'Plant shutdown and turnaround support',
      'Facilities and building M&E maintenance',
      'Fabrication and on-site welding repairs',
      'Spare parts sourcing and reverse engineering',
      'Emergency breakdown response',
    ],
    sections: [
      {
        h: 'Built for plant and facility engineers',
        paragraphs: [
          'Procurement chase is the hidden tax on every maintenance job: three phone calls, two site visits, one quote that never arrives. On Vox Meridian you post the scope once — with photos, P&IDs or equipment lists attached — and matched MRO contractors come back to you with comparable proposals.',
          'Every provider is reviewed for safety credentials before they quote. Documented safety awareness is table stakes for industrial site work, and we verify it up front so your EHS team has one less document to chase.',
        ],
      },
      {
        h: 'For MRO contractors',
        paragraphs: [
          'Stop relying on the same two or three clients for utilisation. Founding providers receive RFQs matched to their trade — mechanical, electrical, facilities or turnaround work — from manufacturers actively looking to buy now.',
          'The founding rate of SGD 29 per month is locked for life for the first thirty providers. You pay only if the channel works for you, and you quote on your own terms with full visibility of scope, budget band and deadline before you commit a site visit.',
        ],
      },
    ],
    sg: {
      keyword: 'industrial MRO services Singapore',
      intro: [
        'Unplanned downtime is the most expensive line item nobody budgets for. When a pump seals, a conveyor fails or a chiller trips at 2 a.m., you need industrial MRO services in Singapore that answer the phone and turn up with the right spares. Vox Meridian routes your maintenance, repair and overhaul RFQs to verified MRO contractors across the island — from Jurong Island process plants to Tuas manufacturing estates.',
        'Post one RFQ describing the asset, the fault or the maintenance scope, and your timeline. We match you with ACRA-registered, bizSAFE-aware MRO providers who have done the same class of work before — rotating equipment, static equipment, facilities and utilities.',
      ],
      sections: [
        {
          h: 'Built for plant and facility engineers',
          paragraphs: [
            'Procurement chase is the hidden tax on every maintenance job: three phone calls, two site visits, one quote that never arrives. On Vox Meridian you post the scope once — with photos, P&IDs or equipment lists attached — and matched MRO contractors come back to you with comparable proposals.',
            'Every provider is reviewed for safety credentials before they quote. bizSAFE awareness is table stakes for site work in Singapore, and we verify it up front so your EHS team has one less document to chase.',
          ],
        },
        {
          h: 'For MRO contractors',
          paragraphs: [
            'Stop relying on the same two or three clients for utilisation. Founding providers receive RFQs matched to their trade — mechanical, electrical, facilities or turnaround work — from manufacturers actively looking to buy now.',
            'The founding rate of SGD 29 per month is locked for life for the first thirty providers. You pay only if the channel works for you, and you quote on your own terms with full visibility of scope, budget band and deadline before you commit a site visit.',
          ],
        },
      ],
    },
  },
  {
    slug: 'industrial-calibration',
    name: 'Industrial Calibration',
    keyword: 'industrial calibration services',
    tagline: 'Accredited instrument calibration, on-site or in-lab.',
    image: IMG.machining,
    intro: [
      'An out-of-tolerance instrument is a quality escape waiting to happen. Whether you run a cleanroom, a pharmaceutical line or a precision job shop, industrial calibration services need to be traceable, accredited and on schedule. Vox Meridian connects your calibration RFQs with verified providers — including ISO/IEC 17025 accredited laboratories — covering dimensional, electrical, pressure, temperature, torque and mass.',
      'Post your instrument list once. Receive comparable quotes for on-site or in-lab calibration with clear turnaround times, so your audit calendar never slips.',
    ],
    servicesTitle: 'Calibration scopes our providers quote on',
    services: [
      'Dimensional — CMM, micrometers, gauges, optical',
      'Electrical — multimeters, oscilloscopes, power',
      'Pressure and vacuum instruments',
      'Temperature — thermocouples, RTDs, furnaces',
      'Torque and force calibration',
      'Mass and balance calibration',
      'On-site calibration for production lines',
      'Calibration management and recall scheduling',
    ],
    sections: [
      {
        h: 'Audit-ready, every time',
        paragraphs: [
          'Your quality team needs certificates that stand up to ISO 9001, ISO 13485 or AS9100 audits. Providers on Vox Meridian quote with their accreditation scope stated up front, so you know before awarding whether the lab covers your parameters and ranges.',
          'Attach your instrument list to the RFQ — make, model, range, and required points — and receive quotes that are directly comparable on price, turnaround and whether pickup and delivery are included.',
        ],
      },
      {
        h: 'For calibration providers',
        paragraphs: [
          'Calibration is a recurring-revenue business, but finding new clients usually means expensive outbound sales. As a founding provider, RFQs from manufacturers with live calibration schedules land in your inbox matched to your accreditation scope.',
          'Founding providers lock SGD 29 per month for life. Verification of your laboratory accreditation and business registration is handled personally by the founder during this concierge phase.',
        ],
      },
    ],
    sg: {
      keyword: 'industrial calibration services Singapore',
      tagline: 'SAC-SINGLAS accredited instrument calibration, on-site or in-lab.',
      intro: [
        'An out-of-tolerance instrument is a quality escape waiting to happen. Whether you run a semicon cleanroom, a pharmaceutical line or a precision job shop, industrial calibration services in Singapore need to be traceable, accredited and on schedule. Vox Meridian connects your calibration RFQs with verified providers — including SAC-SINGLAS accredited laboratories — covering dimensional, electrical, pressure, temperature, torque and mass.',
        'Post your instrument list once. Receive comparable quotes for on-site or in-lab calibration with clear turnaround times, so your audit calendar never slips.',
      ],
      sections: [
        {
          h: 'Audit-ready, every time',
          paragraphs: [
            'Your quality team needs certificates that stand up to ISO 9001, ISO 13485 or AS9100 audits. Providers on Vox Meridian quote with their accreditation scope stated up front, so you know before awarding whether the lab covers your parameters and ranges.',
            'Attach your instrument list to the RFQ — make, model, range, and required points — and receive quotes that are directly comparable on price, turnaround and whether pickup and delivery are included.',
          ],
        },
        {
          h: 'For calibration providers',
          paragraphs: [
            'Calibration is a recurring-revenue business, but finding new clients usually means expensive outbound sales. As a founding provider, RFQs from manufacturers with live calibration schedules land in your inbox matched to your accreditation scope.',
            'Founding providers lock SGD 29 per month for life. Verification of your SAC-SINGLAS accreditation and ACRA registration is handled personally by the founder during this concierge phase.',
          ],
        },
      ],
    },
  },
  {
    slug: 'industrial-electrical',
    name: 'Industrial Electrical',
    keyword: 'industrial electrical services',
    tagline: 'Licensed electrical workers for plants, switchrooms and control panels.',
    image: IMG.electrical,
    intro: [
      'From switchboard upgrades to motor control centres, industrial electrical services demand licensed electrical workers, proper single-line diagrams and zero tolerance for shortcuts. Vox Meridian routes your electrical RFQs to verified contractors — licensed firms that work in factories, warehouses, data centres and process plants.',
      'Post your scope with load schedules, photos of existing installations or single-line diagrams attached. Get matched with registered, insured electrical contractors who quote to the same scope, so comparison is immediate.',
    ],
    servicesTitle: 'Electrical scopes our providers quote on',
    services: [
      'Switchboard and MCC installation and upgrades',
      'Machine wiring and control panel build',
      'Cable laying, containment and termination',
      'Lighting and small power for industrial fit-outs',
      'Power quality and thermographic surveys',
      'Generator, UPS and ATS installation',
      'Explosion-proof and hazardous area work',
      'Preventive maintenance and licensed inspections',
    ],
    sections: [
      {
        h: 'Compliance first',
        paragraphs: [
          'Electrical work is regulated for good reason. Providers on the platform are verified for the licences and insurance your insurer and landlord will ask for — before they quote, not after an incident.',
          'Whether it is a planned switchroom upgrade or an urgent fault-finding callout, your RFQ reaches contractors with the right class of licence and the right headcount for your deadline.',
        ],
      },
      {
        h: 'For electrical contractors',
        paragraphs: [
          'Win industrial work without knocking on doors. Founding providers receive RFQs matched to their licence class and manpower, from manufacturers and facility owners with budget approved and dates set.',
          'The founding rate of SGD 29 per month is locked for life for the first thirty providers. No lead fees, no commission on the jobs you win — a flat rate you can plan around.',
        ],
      },
    ],
    sg: {
      keyword: 'industrial electrical services Singapore',
      intro: [
        'From switchboard upgrades to motor control centres, industrial electrical services in Singapore demand licensed electrical workers, proper single-line diagrams and zero tolerance for shortcuts. Vox Meridian routes your electrical RFQs to verified contractors — LEW-supervised firms that work in factories, warehouses, data centres and process plants across the island.',
        'Post your scope with load schedules, photos of existing installations or single-line diagrams attached. Get matched with ACRA-registered, insured electrical contractors who quote to the same scope, so comparison is immediate.',
      ],
      services: [
        'Switchboard and MCC installation and upgrades',
        'Machine wiring and control panel build',
        'Cable laying, containment and termination',
        'Lighting and small power for industrial fit-outs',
        'Power quality and thermographic surveys',
        'Generator, UPS and ATS installation',
        'Explosion-proof and hazardous area work',
        'Preventive maintenance and LEW inspections',
      ],
      sections: [
        {
          h: 'Compliance first',
          paragraphs: [
            'Electrical work in Singapore is regulated for good reason. Providers on the platform are verified for the licences and insurance your insurer and landlord will ask for — before they quote, not after an incident.',
            'Whether it is a planned switchroom upgrade or an urgent fault-finding callout, your RFQ reaches contractors with the right class of licence and the right headcount for your deadline.',
          ],
        },
        {
          h: 'For electrical contractors',
          paragraphs: [
            'Win industrial work without knocking on doors. Founding providers receive RFQs matched to their licence class and manpower, from manufacturers and facility owners with budget approved and dates set.',
            'The founding rate of SGD 29 per month is locked for life for the first thirty providers. No lead fees, no commission on the jobs you win — a flat rate you can plan around.',
          ],
        },
      ],
    },
  },
  {
    slug: 'automation-integration',
    name: 'Automation Integration',
    keyword: 'automation system integrator',
    tagline: 'PLC, robotics and SCADA integrators for smart factory programmes.',
    image: IMG.automation,
    intro: [
      'Manufacturers everywhere are automating to stay competitive — and the difference between a successful line and an expensive science project is the integrator. Vox Meridian connects you with an automation system integrator matched to your stack: PLC and HMI programming, robotics cells, SCADA and MES connectivity, vision systems and machine retrofits.',
      'Describe your process, your current controls hardware and your target outcome. We match your RFQ to integrators with proven projects on your platform — Siemens, Rockwell, Mitsubishi, Omron, Beckhoff and more.',
    ],
    servicesTitle: 'Integration scopes our providers quote on',
    services: [
      'PLC, HMI and SCADA programming',
      'Robotic cell design and integration',
      'Machine vision inspection systems',
      'Control panel design and build',
      'Machine retrofit and controls upgrades',
      'IIoT, data collection and OEE dashboards',
      'Safety systems and risk assessment',
      'Commissioning, SAT and documentation',
    ],
    sections: [
      {
        h: 'From RFQ to working line',
        paragraphs: [
          'Automation projects fail in the gap between a vague enquiry and a real scope. Our RFQ format forces the right details up front — process description, cycle time targets, existing controls, budget band and deadline — so integrators can quote meaningfully on the first pass.',
          'During the concierge phase the founder personally reviews every automation RFQ and matches it to three to five integrators whose reference projects resemble yours. You compare approaches, not just prices.',
        ],
      },
      {
        h: 'For system integrators',
        paragraphs: [
          'Good integrators are busy; great ones still need a pipeline. Founding providers receive RFQs from manufacturers with real budgets and defined processes — no speculative “what would a robot cost” enquiries.',
          'Lock the founding rate of SGD 29 per month for life. State your platforms and industries once, and only see RFQs that fit your wheelhouse.',
        ],
      },
    ],
    sg: {
      keyword: 'automation system integrator Singapore',
      intro: [
        'Singapore’s manufacturers are automating to stay competitive — and the difference between a successful line and an expensive science project is the integrator. Vox Meridian connects you with an automation system integrator in Singapore matched to your stack: PLC and HMI programming, robotics cells, SCADA and MES connectivity, vision systems and machine retrofits.',
        'Describe your process, your current controls hardware and your target outcome. We match your RFQ to integrators with proven projects on your platform — Siemens, Rockwell, Mitsubishi, Omron, Beckhoff and more.',
      ],
    },
  },
  {
    slug: 'metal-fabrication-welding',
    name: 'Metal Fabrication & Welding',
    keyword: 'metal fabrication services',
    tagline: 'Steel structures, tanks, platforms and pipework — fabricated and welded to spec.',
    image: IMG.electrical,
    intro: [
      'Fabrication keeps process plants, shipyards and infrastructure standing — from structural steel workshops to stainless process pipework. When a drawing calls for coded welds and tight tolerances, the difference between shops is real: qualified welders, controlled procedures and honest lead times. Vox Meridian connects you with metal fabrication services that work to recognised standards — AWS, ASME and local codes — with WPS and PQR documentation ready for your QA file.',
      'Post one RFQ with your drawings attached and receive comparable quotes from verified fabrication and welding providers in your country. Every provider is a registered business, reviewed before they quote — no more ringing five yards to find one with capacity.',
    ],
    servicesTitle: 'Fabrication scopes our providers quote on',
    services: [
      'Structural steel fabrication and erection',
      'Tanks, hoppers and non-code vessels',
      'Pipe spools and process pipe welding',
      'Platforms, walkways, ladders and handrails',
      'Stainless steel and aluminium fabrication',
      'On-site welding and plant repairs',
      'Coded welders with WPS/PQR',
      'Blasting, painting and coating coordination',
    ],
    sections: [
      {
        h: 'How buyers use Vox Meridian for fabrication work',
        paragraphs: [
          'Attach the drawing pack — PDFs, DWGs, material grades, weld maps and any NDT or inspection requirements. Tell us the quantity, site constraints and your required-by date. The founder personally matches your job to three to five shops in your country whose processes, code qualifications and current capacity fit the work — targeting 24–48 hours, and telling you honestly if the match needs more sourcing time.',
          'You receive like-for-like quotes you can actually compare: material supply included or not, surface finish, delivery terms. Because providers know they are competing in a small qualified pool, pricing stays honest and clarifications come fast. Buyers pay nothing during the pilot phase.',
        ],
      },
      {
        h: 'Why fabrication shops join as providers',
        paragraphs: [
          'Most yards live on two or three anchor clients — and when a project ends, the workshop goes quiet. As a founding provider you receive pre-qualified RFQs matched to your processes and capacity: no tender portals, no cold calls, no chasing procurement officers who never reply.',
          'Founding providers lock SGD 29 per month for life. The founder verifies your business registration, welder qualifications and workshop capability personally during this concierge phase — which keeps the buyer experience strong and competition inside the pool fair.',
        ],
      },
    ],
    sg: {
      keyword: 'metal fabrication services Singapore',
      intro: [
        'Singapore’s fabrication trade keeps the island’s process plants, shipyards and infrastructure standing — from structural steel in Tuas workshops to stainless pipework on Jurong Island. When a drawing calls for coded welds and tight tolerances, the difference between shops is real: qualified welders, controlled procedures and honest lead times. Vox Meridian connects you with metal fabrication services in Singapore that work to recognised standards — AWS, ASME and SS codes — with WPS and PQR documentation ready for your QA file.',
        'Post one RFQ with your drawings attached and receive comparable quotes from verified fabrication and welding providers. Every provider is an ACRA-registered entity, reviewed before they quote — no more ringing five yards to find one with capacity.',
      ],
      sections: [
        {
          h: 'How buyers use Vox Meridian for fabrication work',
          paragraphs: [
            'Attach the drawing pack — PDFs, DWGs, material grades, weld maps and any NDT or inspection requirements. Tell us the quantity, site constraints and your required-by date. The founder personally matches your job to three to five Singapore shops whose processes, code qualifications and current capacity fit the work — targeting 24–48 hours, and telling you honestly if the match needs more sourcing time.',
            'You receive like-for-like quotes you can actually compare: material supply included or not, surface finish, delivery terms. Because providers know they are competing in a small qualified pool, pricing stays honest and clarifications come fast. Buyers pay nothing during the pilot phase.',
          ],
        },
        {
          h: 'Why fabrication shops join as providers',
          paragraphs: [
            'Most yards live on two or three anchor clients — and when a project ends, the workshop goes quiet. As a founding provider you receive pre-qualified RFQs matched to your processes and capacity: no tender portals, no cold calls, no chasing procurement officers who never reply.',
            'Founding providers lock SGD 29 per month for life. The founder verifies your ACRA registration, welder qualifications and workshop capability personally during this concierge phase — which keeps the buyer experience strong and competition inside the pool fair.',
          ],
        },
      ],
    },
  },
  {
    slug: 'pumps-motors-gearboxes',
    name: 'Pumps, Motors & Gearboxes',
    keyword: 'pump repair services',
    tagline: 'Overhaul, rewind and alignment for the rotating heart of your plant.',
    image: IMG.machining,
    intro: [
      'Every plant runs on rotating equipment — and every plant engineer has a story about the pump that failed on a Sunday. When a critical motor burns out or a gearbox starts howling, you need pump repair services that respond fast and rebuild properly: strip-down reports, genuine or better-than-OEM parts, and test-run certificates before the unit goes back on the plinth.',
      'Post one RFQ with your equipment details — nameplate photos, running hours, symptoms — and get matched with verified rotating equipment specialists in your country, from overhaul workshops to field service teams that cover your sites.',
    ],
    servicesTitle: 'Rotating equipment scopes our providers quote on',
    services: [
      'Centrifugal and positive displacement pump overhaul',
      'Electric motor rewinding and load testing',
      'Gearbox inspection, repair and rebuild',
      'Laser shaft alignment',
      'Dynamic balancing',
      'Bearing, seal and coupling replacement',
      'Vibration analysis and condition monitoring',
      'Emergency breakdown response',
    ],
    sections: [
      {
        h: 'Built for reliability engineers',
        paragraphs: [
          'Describe the asset and the fault — or the preventive scope if you are planning ahead. Attach photos of the nameplate and installation. We match your RFQ to providers who overhaul your equipment class weekly, so quotes come back with realistic repair-versus-replace options instead of guesswork.',
          'Compare quotes on scope, parts policy and warranty — not just price. A cheap overhaul without a test certificate costs you the next breakdown. Free for buyers during the pilot phase.',
        ],
      },
      {
        h: 'For rotating equipment specialists',
        paragraphs: [
          'Workshop utilisation is the whole game. Founding providers receive RFQs matched to their equipment classes — pumps, motors, gearboxes, blowers — from plants with genuine breakdown or planned maintenance budgets.',
          'Lock the founding rate of SGD 29 per month for life. No lead fees and no commission on the work you win — a flat, predictable channel cost.',
        ],
      },
    ],
    sg: {
      keyword: 'pump repair services Singapore',
      intro: [
        'Every plant runs on rotating equipment — and every plant engineer has a story about the pump that failed on a Sunday. When a critical motor burns out or a gearbox starts howling, you need pump repair services in Singapore that respond fast and rebuild properly: strip-down reports, genuine or better-than-OEM parts, and test-run certificates before the unit goes back on the plinth.',
        'Post one RFQ with your equipment details — nameplate photos, running hours, symptoms — and get matched with verified rotating equipment specialists across the island, from overhaul workshops in Tuas to field service teams covering Jurong Island.',
      ],
    },
  },
  {
    slug: 'hvac-industrial-refrigeration',
    name: 'HVAC & Industrial Refrigeration',
    keyword: 'industrial refrigeration services',
    tagline: 'Chillers, cold rooms and factory ventilation — uptime you can plan around.',
    image: IMG.automation,
    intro: [
      'In hot climates and process plants alike, cooling isn’t comfort — it’s production infrastructure. A chiller trip means a warm cleanroom, a sweating warehouse, or a cold chain breach with your name on the incident report. Vox Meridian routes your RFQs to verified industrial refrigeration services: chiller specialists, cold room builders, ventilation contractors and controls technicians who understand process-critical environments.',
      'Post your scope once — equipment list, tonnage, photos of the plant room — and receive comparable quotes from registered, insured providers with the refrigerant handling licences your compliance team expects.',
    ],
    servicesTitle: 'Cooling scopes our providers quote on',
    services: [
      'Chiller servicing, overhaul and retrofits',
      'Cold room and freezer room build and maintenance',
      'AHU, FCU and ventilation system servicing',
      'Factory exhaust and fume extraction',
      'Refrigerant leak detection and recharge',
      'Cooling tower maintenance and water treatment',
      'BMS and controls integration',
      'Emergency cooling breakdown response',
    ],
    sections: [
      {
        h: 'For facility and plant teams',
        paragraphs: [
          'Attach your equipment schedule and describe the fault or maintenance scope. We match you with providers experienced in your environment — food plants, pharma, logistics cold chain, electronics — so the quotes reflect real understanding of your hygiene and uptime requirements.',
          'Every provider is verified before quoting: business registration, insurance, and the licences refrigerant work legally requires. Free for buyers during the pilot phase.',
        ],
      },
      {
        h: 'For HVAC and refrigeration contractors',
        paragraphs: [
          'Founding providers receive RFQs matched to their capability — chillers, cold rooms, ventilation or controls — from facilities with live budgets and real deadlines. No more quoting against phantom enquiries.',
          'Lock SGD 29 per month for life as one of the first thirty providers. Flat rate, no commission, cancel anytime — a channel you can plan around.',
        ],
      },
    ],
    sg: {
      keyword: 'industrial refrigeration services Singapore',
      tagline: 'Chillers, cold rooms and factory ventilation — uptime in the tropics.',
      intro: [
        'In Singapore’s climate, cooling isn’t comfort — it’s production infrastructure. A chiller trip means a warm cleanroom, a sweating warehouse, or a cold chain breach with your name on the incident report. Vox Meridian routes your RFQs to verified industrial refrigeration services in Singapore: chiller specialists, cold room builders, ventilation contractors and controls technicians who understand process-critical environments.',
        'Post your scope once — equipment list, tonnage, photos of the plant room — and receive comparable quotes from ACRA-registered, insured providers with the refrigerant handling licences your compliance team expects.',
      ],
      sections: [
        {
          h: 'For facility and plant teams',
          paragraphs: [
            'Attach your equipment schedule and describe the fault or maintenance scope. We match you with providers experienced in your environment — food plants, pharma, logistics cold chain, electronics — so the quotes reflect real understanding of your hygiene and uptime requirements.',
            'Every provider is verified before quoting: ACRA registration, insurance, and the licences refrigerant work legally requires in Singapore. Free for buyers during the pilot phase.',
          ],
        },
        {
          h: 'For HVAC and refrigeration contractors',
          paragraphs: [
            'Founding providers receive RFQs matched to their capability — chillers, cold rooms, ventilation or controls — from facilities with live budgets and real deadlines. No more quoting against phantom enquiries.',
            'Lock SGD 29 per month for life as one of the first thirty providers. Flat rate, no commission, cancel anytime — a channel you can plan around.',
          ],
        },
      ],
    },
  },
  {
    slug: 'hydraulic-services',
    name: 'Hydraulic Services',
    keyword: 'hydraulic services',
    tagline: 'Cylinders, power packs and hose assemblies — pressure you can trust.',
    image: IMG.machining,
    intro: [
      'Hydraulics do the heavy lifting in factories, yards and marine industries — and when a cylinder blows its seals or a power pack loses pressure, production stops with it. Vox Meridian connects you with hydraulic services covering everything from while-you-wait hose assemblies to complete power pack rebuilds, cylinder honing and system flushing to ISO cleanliness codes.',
      'Post one RFQ with photos, port sizes and pressure ratings, and get matched with verified hydraulic specialists — workshops with test benches and mobile hose vans that come to your breakdown.',
    ],
    servicesTitle: 'Hydraulic scopes our providers quote on',
    services: [
      'Hydraulic cylinder repair, re-sealing and honing',
      'Power pack design, build and overhaul',
      'Hose assemblies, fittings and adaptors',
      'Hydraulic pump and motor testing',
      'System flushing and oil analysis',
      'Press, lift and platform repairs',
      'On-site troubleshooting and commissioning',
      'Mobile hose replacement service',
    ],
    sections: [
      {
        h: 'For maintenance teams',
        paragraphs: [
          'Describe the symptom and the system — working pressure, oil type, cylinder bore and stroke if you have them. Photos of the failed component help enormously. Matched providers quote repair against replacement with realistic turnaround, so you decide with numbers instead of hope.',
          'All providers are verified registered businesses, insured before they quote. Posting an RFQ is free during the pilot phase.',
        ],
      },
      {
        h: 'For hydraulic workshops',
        paragraphs: [
          'Founding providers receive RFQs matched to their bench capacity and service range — cylinders, power packs, hoses or field service — from plants and yards that need the work done now.',
          'Lock the founding rate of SGD 29 per month for life. No commission on jobs won — just a flat monthly rate and a steady flow of matched work.',
        ],
      },
    ],
    sg: {
      keyword: 'hydraulic services Singapore',
      intro: [
        'Hydraulics do the heavy lifting in Singapore’s factories, yards and marine industry — and when a cylinder blows its seals or a power pack loses pressure, production stops with it. Vox Meridian connects you with hydraulic services in Singapore covering everything from while-you-wait hose assemblies to complete power pack rebuilds, cylinder honing and system flushing to ISO cleanliness codes.',
        'Post one RFQ with photos, port sizes and pressure ratings, and get matched with verified hydraulic specialists — workshops with test benches and mobile hose vans that come to your breakdown.',
      ],
      sections: [
        {
          h: 'For maintenance teams',
          paragraphs: [
            'Describe the symptom and the system — working pressure, oil type, cylinder bore and stroke if you have them. Photos of the failed component help enormously. Matched providers quote repair against replacement with realistic turnaround, so you decide with numbers instead of hope.',
            'All providers are ACRA-verified and insured before they quote. Posting an RFQ is free during the pilot phase.',
          ],
        },
        {
          h: 'For hydraulic workshops',
          paragraphs: [
            'Founding providers receive RFQs matched to their bench capacity and service range — cylinders, power packs, hoses or field service — from plants and yards that need the work done now.',
            'Lock the founding rate of SGD 29 per month for life. No commission on jobs won — just a flat monthly rate and a steady flow of matched work.',
          ],
        },
      ],
    },
  },
  {
    slug: 'industrial-piping',
    name: 'Industrial Piping',
    keyword: 'industrial piping services',
    tagline: 'Process piping, utility lines and leak repairs — welded, tested, certified.',
    image: IMG.electrical,
    intro: [
      'From utility headers in a factory to process lines in a refinery, industrial piping services demand more than a welder with a machine: spool drawings, material traceability, hydrotest packs and welders qualified to the codes your insurer and client expect. Vox Meridian routes your piping RFQs to verified contractors who work to ASME B31 and local standards, with documentation habits that survive audits.',
      'Post your scope — line list, isometrics if you have them, photos of the tie-in points if you don’t — and receive comparable quotes from registered piping specialists with proven shutdown and live-plant experience.',
    ],
    servicesTitle: 'Piping scopes our providers quote on',
    services: [
      'Process pipe fabrication and installation',
      'Utility lines — air, water, steam, gas',
      'Leak detection and permanent repair',
      'Hydrotesting, flushing and reinstatement',
      'Pipe supports, hangers and spring cans',
      'Shutdown tie-ins and hot work',
      'Stainless steel and exotic alloy welding',
      'Insulation and cladding coordination',
    ],
    sections: [
      {
        h: 'For plant and project engineers',
        paragraphs: [
          'Attach the line list or isometrics and state your test and documentation requirements up front — providers quote knowing the full compliance scope, so there are no surprises at hydrotest. The founder matches your RFQ to three to five contractors with the right welder qualifications and available crews.',
          'Compare quotes on the same scope: materials supply, NDT percentages, test packs and reinstatement included or excluded. Free for buyers during the pilot phase.',
        ],
      },
      {
        h: 'For piping contractors',
        paragraphs: [
          'Founding providers receive RFQs matched to their code qualifications and crew size — from small utility runs to shutdown tie-ins — from buyers with approved budgets and fixed windows.',
          'Lock SGD 29 per month for life. Verified by the founder personally, flat rate, no commission. When the thirty founding spots are gone, the rate is gone with them.',
        ],
      },
    ],
    sg: {
      keyword: 'industrial piping services Singapore',
      intro: [
        'From utility headers in a Tuas factory to process lines on Jurong Island, industrial piping services in Singapore demand more than a welder with a machine: spool drawings, material traceability, hydrotest packs and welders qualified to the codes your insurer and client expect. Vox Meridian routes your piping RFQs to verified contractors who work to ASME B31 and local standards, with documentation habits that survive audits.',
        'Post your scope — line list, isometrics if you have them, photos of the tie-in points if you don’t — and receive comparable quotes from ACRA-registered piping specialists with proven shutdown and live-plant experience.',
      ],
    },
  },
];

export const CATEGORY_SERVICE_MAP = {
  'precision-machining': 'Precision machining',
  'mro-services': 'Machinery maintenance & repair',
  'industrial-calibration': 'Instrumentation & calibration',
  'industrial-electrical': 'Electrical services',
  'automation-integration': 'Industrial automation',
};

export const SERVICES = [
  { name: 'Machinery maintenance & repair', examples: 'Production machinery servicing, breakdown repairs' },
  { name: 'Electrical services', examples: 'Factory wiring, switchboards, motor controls' },
  { name: 'Industrial automation', examples: 'PLC programming, SCADA, robotics integration' },
  { name: 'Instrumentation & calibration', examples: 'Pressure gauges, temperature sensors, weighing scales' },
  { name: 'Mechanical engineering', examples: 'Machinery modifications, alignment, installation' },
  { name: 'Metal fabrication & welding', examples: 'Steel structures, platforms, tanks, pipe welding' },
  { name: 'Precision machining', examples: 'CNC milling, turning, grinding, replacement parts' },
  { name: 'Hydraulic services', examples: 'Hydraulic cylinders, power packs, hose assemblies' },
  { name: 'Pneumatic services', examples: 'Air cylinders, valves, pneumatic system repairs' },
  { name: 'Pumps, motors & gearboxes', examples: 'Pump overhaul, motor rewinding, gearbox repairs' },
  { name: 'Air compressor services', examples: 'Compressor maintenance, air dryers, leak detection' },
  { name: 'HVAC & industrial refrigeration', examples: 'Factory ventilation, chillers, cold rooms' },
  { name: 'Boilers & steam systems', examples: 'Boiler servicing, steam traps, insulation' },
  { name: 'Industrial piping', examples: 'Process piping, utility lines, leak repairs' },
  { name: 'Water & wastewater treatment', examples: 'Treatment plant maintenance, filtration, water testing' },
  { name: 'Industrial cleaning', examples: 'Machinery degreasing, tank cleaning, high-pressure washing' },
  { name: 'Waste management & recycling', examples: 'Scrap collection, industrial waste handling' },
  { name: 'Inspection & testing', examples: 'Nondestructive testing, weld inspection, material testing' },
  { name: 'Workplace safety services', examples: 'Risk assessments, safety audits, industrial hygiene' },
  { name: 'Fire protection systems', examples: 'Fire alarms, sprinklers, suppression system maintenance' },
  { name: 'Lifting equipment services', examples: 'Crane, hoist and lifting gear inspection and repairs' },
  { name: 'Material handling equipment', examples: 'Forklift servicing, conveyor repairs, loading docks' },
  { name: 'Machinery installation & relocation', examples: 'Rigging, dismantling, factory moves, commissioning' },
  { name: 'Surface treatment & protective coatings', examples: 'Blasting, industrial painting, plating, powder coating' },
  { name: 'Tooling, moulds & dies', examples: 'Mould repairs, die making, jigs and fixtures' },
  { name: 'Rubber & plastic engineering', examples: 'Roller relining, seals, plastic welding, custom components' },
  { name: 'Factory building maintenance', examples: 'Industrial flooring, roofing, drainage, civil repairs' },
  { name: 'Energy efficiency services', examples: 'Energy audits, power quality analysis, efficiency upgrades' },
  { name: 'Engineering design & consulting', examples: 'CAD drafting, process design, project management' },
  { name: 'Contract manufacturing & assembly', examples: 'Outsourced production, assembly, packing' },
  { name: 'Industrial IT & networking', examples: 'Factory networks, industrial computers, OT cybersecurity' },
  { name: 'Technical manpower & training', examples: 'Maintenance technicians, shutdown crews, operator training' },
  { name: 'Industrial logistics & warehousing', examples: 'Heavy transport, freight forwarding, storage' },
  { name: 'Marine & offshore services', examples: 'Vessel repairs, marine electrical work, offshore maintenance' },
];

const TRADE_IMAGES = {
  'precision-machining': IMG.machining,
  'mro-services': 'https://images.unsplash.com/photo-1565377167263-d29b5ac85479?q=85&w=1600&auto=format&fit=crop',
  'industrial-calibration': 'https://images.unsplash.com/photo-1759571796674-295d4e332813?q=85&w=1600&auto=format&fit=crop',
  'industrial-electrical': IMG.electrical,
  'automation-integration': IMG.automation,
  'metal-fabrication-welding': 'https://images.unsplash.com/photo-1455165814004-1126a7199f9b?q=85&w=1600&auto=format&fit=crop',
  'pumps-motors-gearboxes': 'https://images.unsplash.com/photo-1558382689-c1c29cc9b37e?q=85&w=1600&auto=format&fit=crop',
  'hvac-industrial-refrigeration': 'https://images.unsplash.com/photo-1774290331891-5d759056c68d?q=85&w=1600&auto=format&fit=crop',
  'hydraulic-services': 'https://images.unsplash.com/photo-1766157669300-8ade8059b379?q=85&w=1600&auto=format&fit=crop',
  'industrial-piping': 'https://images.unsplash.com/photo-1620203853151-496c7228306c?q=85&w=1600&auto=format&fit=crop',
};
CATEGORIES.forEach((c) => {
  if (TRADE_IMAGES[c.slug]) c.image = TRADE_IMAGES[c.slug];
});

export const SERVICE_PAGE_SLUG = {
  'Machinery maintenance & repair': 'mro-services',
  'Electrical services': 'industrial-electrical',
  'Industrial automation': 'automation-integration',
  'Instrumentation & calibration': 'industrial-calibration',
  'Precision machining': 'precision-machining',
  'Metal fabrication & welding': 'metal-fabrication-welding',
  'Hydraulic services': 'hydraulic-services',
  'Pumps, motors & gearboxes': 'pumps-motors-gearboxes',
  'HVAC & industrial refrigeration': 'hvac-industrial-refrigeration',
  'Industrial piping': 'industrial-piping',
};

// `seoName` reads naturally inside sentences and titles ("in the UAE").
// `hubs` and `blurb` power the per-country trade pages (/services/<slug>/<country>).
export const COUNTRIES = [
  {
    code: 'SG',
    name: 'Singapore',
    seoName: 'Singapore',
    hubs: ['Tuas', 'Jurong Island', 'Woodlands', 'Ubi', 'Changi'],
    blurb:
      'Singapore packs a global hub for precision engineering, semiconductors, aerospace MRO and process industries onto one island — from the wafer fabs of Woodlands to the refineries and chemical plants of Jurong Island.',
  },
  {
    code: 'MY',
    name: 'Malaysia',
    seoName: 'Malaysia',
    hubs: ['Johor Bahru', 'Pasir Gudang', 'Penang', 'Shah Alam', 'Batu Kawan'],
    blurb:
      'Penang anchors one of the world’s largest electronics and semiconductor clusters, while Johor’s Pasir Gudang and the Klang Valley carry heavy process, petrochemical and general manufacturing industry.',
  },
  {
    code: 'AE',
    name: 'UAE (Dubai)',
    seoName: 'the UAE',
    hubs: ['Jebel Ali', 'Dubai Industrial City', 'KIZAD Abu Dhabi', 'Sharjah Industrial Area'],
    blurb:
      'Jebel Ali and Dubai Industrial City form the region’s logistics and light-manufacturing core, with Abu Dhabi’s industrial zones serving energy, marine and heavy fabrication work.',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    seoName: 'the United Kingdom',
    hubs: ['The Midlands', 'Sheffield', 'Manchester', 'Aberdeen', 'Teesside'],
    blurb:
      'From the Midlands’ advanced-manufacturing belt to Aberdeen’s energy services and Sheffield’s metals heritage, the UK runs one of Europe’s deepest industrial supplier bases.',
  },
  {
    code: 'AU',
    name: 'Australia',
    seoName: 'Australia',
    hubs: ['Perth', 'Melbourne', 'Sydney', 'Brisbane', 'Adelaide'],
    blurb:
      'Mining and resources services out of Perth, manufacturing around Melbourne and Sydney, and food, beverage and defence programmes nationwide keep Australian industrial contractors busy.',
  },
  {
    code: 'US',
    name: 'United States',
    seoName: 'the United States',
    hubs: ['Houston', 'Chicago', 'Detroit', 'Los Angeles', 'Cleveland'],
    blurb:
      'The largest industrial market in the world — energy on the Gulf Coast, automotive around Detroit, aerospace on the coasts and machining job shops in every state.',
  },
  {
    code: 'CA',
    name: 'Canada',
    seoName: 'Canada',
    hubs: ['Toronto', 'Montreal', 'Calgary', 'Hamilton', 'Vancouver'],
    blurb:
      'Ontario’s automotive corridor, Montreal’s aerospace cluster and Alberta’s energy services give Canada a concentrated, highly certified industrial supplier base.',
  },
  {
    code: 'ZA',
    name: 'South Africa',
    seoName: 'South Africa',
    hubs: ['Johannesburg', 'Durban', 'Gqeberha', 'Cape Town', 'Secunda'],
    blurb:
      'Africa’s most industrialised economy — mining services around Johannesburg, automotive in Gqeberha and East London, petrochemicals at Secunda and port industry in Durban.',
  },
];

// ---- Expansion packs (2026-10): 65 services total, 1 vertical, 5 sector hubs,
// India + Europe (10 markets). Guards keep hot-reload re-evaluation idempotent. ----
if (!CATEGORIES.some((c) => c.slug === 'field-machining')) {
  CATEGORIES.push(...EXPANSION_CATEGORIES);
  SERVICES.push(EXPANSION_SERVICE);
  Object.assign(CATEGORY_SERVICE_MAP, EXPANSION_SERVICE_MAP);
  Object.assign(SERVICE_PAGE_SLUG, EXPANSION_PAGE_SLUGS);
}
if (!CATEGORIES.some((c) => c.slug === 'payroll-processing')) {
  CATEGORIES.push(...BUSINESS_CATEGORIES);
  SERVICES.push(...BUSINESS_SERVICES);
  Object.assign(SERVICE_PAGE_SLUG, BUSINESS_PAGE_SLUGS);
}
if (!CATEGORIES.some((c) => c.slug === 'plc-controls-modernisation')) {
  CATEGORIES.push(...PROGRAMME_CATEGORIES);
  SERVICES.push(...PROGRAMME_SERVICES);
  Object.assign(SERVICE_PAGE_SLUG, PROGRAMME_PAGE_SLUGS);
}
if (!COUNTRIES.some((c) => c.code === 'IN')) COUNTRIES.push(INDIA, EUROPE);
export { VERTICALS, FEATURED_SLUGS, HOME_SLUGS } from './site-expansion';
export { SECTORS, SERVICE_GROUPS } from './site-sectors';

export const BUDGET_RANGES = [
  'Under SGD 5,000',
  'SGD 5,000 – 20,000',
  'SGD 20,000 – 50,000',
  'SGD 50,000 – 150,000',
  'Above SGD 150,000',
  'Not sure yet',
];

export const DELIVERY_MODES = [
  { id: 'on_site', name: 'On-site at my location' },
  { id: 'remote', name: 'Remote / online' },
  { id: 'ship_to', name: 'Ship-to workshop' },
  { id: 'travel', name: 'Provider can travel / hybrid' },
];
